/**
 * http://usejsdoc.org/
 */

export const urls = {
	reservationApiUrl : 'http://localhost:4000/',
	mainApiUrl: 'http://localhost:3001',
	paymentsApiUrl: 'https://api.cert.nabcommerce.com/REST/2.0.18',
	terminalApiUrl: 'https://10.0.0.176:6300/',
	backgroundUrl: 'https://i.imgur.com/psEAf7w.jpg'
}

 
